import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt, FaArrowRight, FaWhatsapp } from 'react-icons/fa';
import {
  WHATSAPP_URL,
  PHONE_URL,
  PHONE_DISPLAY,
  EMAIL_URL,
  CONTACT_EMAIL,
  LINKEDIN_URL,
  COMPANY_ADDRESS,
} from '../utils/contact';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A2540] text-white mt-auto">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-6" aria-label="GEOTS Consulting - Accueil">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#635BFF] to-[#00D4FF] flex items-center justify-center">
                <span className="text-white font-bold text-lg" aria-hidden="true">G</span>
              </div>
              <span className="text-xl font-bold text-white">
                GEOTS<span className="text-[#635BFF]">.consulting</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm mb-6 max-w-sm">
              Marketplace B2B 100% spécialisée géotechnique et fondations spéciales. 
              Mise en relation entre fournisseurs d&apos;équipements et clients professionnels.
            </p>

            {/* Direct contact buttons (replaces dead social media icons) */}
            <div className="space-y-3">
              <p className="text-sm font-semibold text-white mb-3">Contact direct</p>
              <div className="flex flex-wrap gap-2">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 text-[#25D366] px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                  aria-label="Contacter sur WhatsApp"
                >
                  <FaWhatsapp size={16} aria-hidden="true" />
                  <span>WhatsApp</span>
                </a>
                <a
                  href={EMAIL_URL}
                  className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                  aria-label={`Envoyer un email à ${CONTACT_EMAIL}`}
                >
                  <FaEnvelope size={14} aria-hidden="true" />
                  <span>Email</span>
                </a>
                <a
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#0077B5]/10 hover:bg-[#0077B5]/20 text-[#0077B5] px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                  aria-label="Suivre GEOTS sur LinkedIn"
                >
                  <FaLinkedin size={16} aria-hidden="true" />
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
          </div>

          {/* Plateforme */}
          <nav aria-label="Plateforme">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Plateforme
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Boutique</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/rental" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Location</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/directory" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Annuaire</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/encheres" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Enchères</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/encheres/devenir-vendeur" className="text-[#F0A22E] hover:text-[#ffc266] transition-colors text-sm flex items-center gap-2 group font-medium">
                  <span>Devenir vendeur</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/requests" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Demandes</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/talents" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Talents</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/comparateur" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Comparateur</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Tarifs</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
            </ul>
          </nav>

          {/* Ressources */}
          <nav aria-label="Ressources">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Ressources
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/guides" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Tous les guides</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/guides/comment-choisir-foreuse-geotechnique" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Choisir une foreuse</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/comment-ca-marche" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>Comment ça marche</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2 group">
                  <span>À propos</span>
                  <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
                </Link>
              </li>
            </ul>
          </nav>

          {/* Légal */}
          <nav aria-label="Mentions légales">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Légal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/legal-notice" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors text-sm">
                  CGU
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Cookies
                </Link>
              </li>
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <FaEnvelope className="text-xs" aria-hidden="true" />
                </div>
                <a href={EMAIL_URL} className="hover:text-white transition-colors">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <FaPhone className="text-xs" aria-hidden="true" />
                </div>
                <a href={PHONE_URL} className="hover:text-white transition-colors">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <FaMapMarkerAlt className="text-xs" aria-hidden="true" />
                </div>
                <span>
                  {COMPANY_ADDRESS.city}, {COMPANY_ADDRESS.country}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} GEOTS.consulting - Tous droits réservés.
            </p>
            <p className="text-gray-500 text-xs">
              Siège social : {COMPANY_ADDRESS.city}, {COMPANY_ADDRESS.country}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
